import { formValueToMagicLink } from 'community/utils/magicLink';
import { formValueToOtp } from 'community/utils/otp';

// The form stores 3-state auth settings as strings ('default'|'enabled'|'disabled') for RadioGroup
// compatibility. Convert each to boolean|null for the API. If the value is already boolean|null
// (non-form callers), leave it untouched.
const convertThreeStateSetting = (
  settings: Record<string, unknown>,
  key: string,
  toApi: (value: string) => boolean | null
): Record<string, unknown> => {
  const value = settings[key];
  if (typeof value !== 'string') return settings;

  return { ...settings, [key]: toApi(value) };
};

const convertAuthSettings = (settings: Record<string, unknown>): Record<string, unknown> => {
  const withMagicLink = convertThreeStateSetting(settings, 'magicLinkAuthEnabled', formValueToMagicLink);
  return convertThreeStateSetting(withMagicLink, 'otpAuthEnabled', formValueToOtp);
};

export const mapCommunityToApi = (data: object) => {
  const { communitySettings, ...rest } = data as Record<string, unknown>;

  return {
    ...rest,
    ...(communitySettings
      ? { communitySettings: convertAuthSettings(communitySettings as Record<string, unknown>) }
      : {}),
    // TODO remove after its no longer required by backend
    calendarPermissionsRequired: false,
  };
};
